<div class="row m-0 pt-1">
  <div class="mt-2 col-md-12">
    <mat-form-field class="width-100" appearance="outline">
      <mat-label>CPF/CNPJ </mat-label>
      <input
        matInput
        type="text"
        [formControl]="form.get('cpf_cnpj')"
        mask="000.000.000-00||00.000.000/0000-00"
        (blur)="checkCpfCnpj()"
      />
    </mat-form-field>
    <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('repeated')">
      {{ messages.cpf_cnpj.repeated }}
    </small>
    <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('required')">
      {{ messages.cpf_cnpj.required }}
    </small>
    <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('pattern')">
      {{ messages.cpf_cnpj.pattern }}
    </small>
    <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('duplicate')">
      {{ messages.cpf_cnpj.duplicate }}
    </small>
    <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('maxlength')">
      {{ messages.cpf_cnpj.maxlength }}
    </small>
    <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('validateCPF')">
      {{ messages.cpf_cnpj.validateCPF }}
    </small>
    <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('validateCNPJ')">
      {{ messages.cpf_cnpj.validateCNPJ }}
    </small>
  </div>

  <div class="mt-2 col-md-12">
    <mat-form-field class="width-100" appearance="outline">
      <mat-label>Nome/razão social </mat-label>
      <input
        matInput
        type="text"
        [formControl]="form.get('nome_razao_social')"
      />
    </mat-form-field>
    <small class="p-error" *ngIf="form.get('nome_razao_social').hasError('required')">
      {{ messages.nome_razao_social.required }}
    </small>
    <small class="p-error" *ngIf="form.get('nome_razao_social').hasError('maxlength')">
      {{ messages.nome_razao_social.maxlength }}
    </small>
    <small class="p-error" *ngIf="form.get('nome_razao_social').hasError('minlength')">
      {{ messages.nome_razao_social.minlength }}
    </small>
    <small class="p-error" *ngIf="form.get('nome_razao_social').hasError('isEmptyValue')">
      {{ messages.nome_razao_social.isEmptyValue }}
    </small>
  </div>

  <div class="mt-2 col-md-12">
    <mat-form-field class="width-100" appearance="outline">
      <mat-label>Apelido/nome fantasia</mat-label>
      <input
        matInput
        type="text"
        [formControl]="form.get('apelido_nome_fantasia')"
      />
    </mat-form-field>
    <small class="p-error"
      *ngIf="form.get('apelido_nome_fantasia').hasError('maxlength')"
    >
      {{ messages.apelido_nome_fantasia.maxlength }}
    </small>
    <small class="p-error"
      *ngIf="form.get('apelido_nome_fantasia').hasError('minlength')"
    >
      {{ messages.nome_razao_social.minlength }}
    </small>
    <small class="p-error"
      *ngIf="form.get('apelido_nome_fantasia').hasError('isEmptyValue')"
    >
      {{ messages.nome_razao_social.isEmptyValue }}
    </small>
  </div>

  <div class="mt-2 col-md-12">
    <mat-form-field class="width-100" appearance="outline">
      <mat-label>Inscrição estadual/RG</mat-label>
      <input
        matInput
        type="text"
        (keydown)="notText($event)"
        (blur)="checkRgInscEstadual()"
        [formControl]="form.get('rg_insc_est')"
      />
    </mat-form-field>
    <small class="p-error" *ngIf="form.get('rg_insc_est').hasError('pattern')">
      {{ messages.rg_insc_est.pattern }}
    </small>
    <small class="p-error" *ngIf="form.get('rg_insc_est').hasError('maxlength')">
      {{ messages.rg_insc_est.maxlength }}
    </small>
    <small class="p-error" *ngIf="form.get('rg_insc_est').hasError('duplicate')">
      {{ messages.rg_insc_est.duplicate }}
    </small>
    <small class="p-error" *ngIf="form.get('rg_insc_est').hasError('existSpecialChar')">
      {{ messages.rg_insc_est.existSpecialChar }}
    </small>
    <small class="p-error" *ngIf="form.get('rg_insc_est').hasError('isEmptyValue')">
      {{ messages.rg_insc_est.isEmptyValue }}
    </small>
  </div>
</div>
